<button
  ngxClipboard
  (cbOnSuccess)="notify ? notyService.notify(successNotificationMessage || 'Copied', 'success') : ''"
  (cbOnError)="notify ? notyService.notify(errorNotificationMessage || 'Error copying', 'error') : ''"
  [cbContent]="content"
  [class]="cssClassBtn + ' ' + (small ? 'btn-sm' : '') + ' ' + cssClassPadding"
  [attr.title]="title ? title : null"
>
  <span *ngIf="btnText">{{ btnText }}</span>
  <span *ngIf="!btnText"><i class="fas fa-clipboard"></i></span>
</button>
